import React, { useState, useEffect } from 'react';
import signinimage from '../asserts/img/logo.png';
import { toast } from 'react-toastify';
import Button from '../components/Button';
import { useDispatch, useSelector } from 'react-redux';
import { signin } from '../slice/userSlice';
import { useNavigate } from 'react-router-dom';

function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [rememberMe, setRememberMe] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading, error, response, message } = useSelector(state => state.user);

    useEffect(() => {
        if (response && response?.data?.access_token) {
            if (rememberMe) {
                localStorage.setItem('userToken', response.data.token); 
            } else {
                sessionStorage.setItem('userToken', response.data.token); 
            }
            // window.location.href = '/dashboard';
            navigate('/customerorder')
        } else if (error) {
            toast(message || 'Something went wrong');
        }
    }, [response, error, navigate, message, dispatch]);

    const loginHandler = async (e) => {
        e.preventDefault();
        dispatch(signin({ username, password }));
    };

    const handleRememberMeChange = (e) => {
        setRememberMe(e.target.checked);
    };

    return (
        <section className="sign-in" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', background: '#f4f6f9' }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-8 col-lg-10 col-md-12">
                        <div className="card o-hidden border-0 my-5" style={{ background: 'linear-gradient(145deg, #082032 0%, #0EA5A4 100%)', borderRadius: '20px', boxShadow: '0 25px 50px rgba(0,0,0,0.5)' }}>
                            <div className="card-body p-0">
                                <div className="row mt-5 mb-5 align-items-center">
                                    <div className="col-lg-6 d-none d-lg-block text-center">
                                        <img src={signinimage} alt='login' className='img-fluid loginimg' style={{ borderRadius: '15px', padding: '20px' }} />
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="p-5" style={{ background: 'rgba(255, 255, 255, 0.1)', backdropFilter: 'blur(10px)', borderRadius: '15px', marginRight: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.3)' }}>
                                            <div className="text-center">
                                                <h1 className="h4 mb-4 text-white"><strong>Welcome Admin</strong></h1>
                                            </div>
                                            <form className="user" onSubmit={loginHandler}>
                                                <div className="form-group">
                                                    <input 
                                                        type="email" 
                                                        className="form-control form-control-user"
                                                        placeholder="Enter Email Address..."  
                                                        onChange={(e) => setUsername(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <input 
                                                        type="password" 
                                                        className="form-control form-control-user"
                                                        placeholder="Password" 
                                                        onChange={(e) => setPassword(e.target.value)}
                                                        autoComplete="current-password"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <div className="custom-control custom-checkbox small">
                                                        <input 
                                                            type="checkbox" 
                                                            className="custom-control-input" 
                                                            id="customCheck" 
                                                            checked={rememberMe}
                                                            onChange={handleRememberMeChange}
                                                        />
                                                        <label 
                                                            className="custom-control-label text-white" 
                                                            htmlFor="customCheck"
                                                        >
                                                            Remember Me
                                                        </label>
                                                    </div>
                                                </div>
                                                <Button 
                                                    onclickfun={loginHandler} 
                                                    disabled={loading} 
                                                    className="btn btn-user btn-block text-white font-weight-bold" 
                                                    style={{ background: 'linear-gradient(90deg, #10B981 0%, #0EA5A4 100%)', border: 'none', borderRadius: '30px', padding: '12px', fontSize: '16px', boxShadow: '0 4px 15px rgba(14, 165, 164, 0.4)' }}
                                                    text="Login"
                                                />
                                            
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Login;
